export default "__VITE_ASSET__80204930__"